import { chatApiAxios } from "@/plugins";
import { checkAccessTokenAsync } from "@/services/maitrejaApi/auth/checkAccessTokenAsync";
import { Attachment, MessageType } from "@/store/chats/types";
import { HttpRequestMethodEnum } from "@/types/api";

interface CreateChat {
  memberIds: string[];
  messageText?: string;
  chatId: string;
  attachments?: Attachment[];
  messageId: string;
  messageType: MessageType;
}

export const createChatBeAsync = async ({
  memberIds,
  messageText,
  chatId,
  attachments = [],
  messageId,
  messageType,
}: CreateChat) => {
  const accessToken = await checkAccessTokenAsync();

  const headers = {
    Authorization: `Bearer ${accessToken}`,
  };
  const res = await chatApiAxios("chat", {
    method: HttpRequestMethodEnum.POST,
    headers,
    data: {
      memberIds,
      message: messageText,
      chatId,
      attachments,
      messageId,
      messageType,
    },
  });
  return res.data;
};
